module.exports = __webpack_public_path__ + "static/media/bottle-row.5164ab0f.svg";